// extracted by mini-css-extract-plugin
module.exports = {"bottomButton":"alert-with-close-button_bottomButton__uXwSg"};